import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type BoardDeletionTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type DeleteBoardPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<BoardDeletionTask>, 'boardIds'>;
  onCancel: () => void;
};

export const DeleteBoardPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { boardIds } }: DeleteBoardPanelInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const classicTitle = `Deleting ${pluralize('board', boardIds.length, true)}`;
    const title = ui2026 && boardIds.length === 1 ? 'Deleting board' : classicTitle;

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? `${title}…` : title}</FileStatusTitle>}
        buttons={<TaskPaneCancelOrHideButton onClick={onCancel} />}
      />
    );
  },
);

DeleteBoardPanelInProgressPanelItem.displayName = 'DeleteBoardPanelInProgressPanelItem';
